<template>
	<div class="videolist">
		<div class="breadcrumb">竞赛管理 > 竞赛列表</div>
		<div class="searchBtn" style="border:none;display:flex">
	      	<el-button size='small' type="primary" @click="add" plain>创建赛场</el-button>
	      	<el-button size='small' type="warning" @click="edit" plain>编辑</el-button>
	      	<el-button size='small' type="danger" @click="del" plain >删除</el-button>
	      	<el-select v-model="sportsKindId" placeholder="请选择运动类型" style="margin-left:10px">
			    <el-option
			      v-for="item in sportsKindList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>

			<el-select v-model="raceScaleId" placeholder="请选择竞赛规则" style="margin-left:10px">
			    <el-option
			      v-for="item in ruleContest"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
			<el-select v-model="raceFormatId" placeholder="请选择竞赛类型" style="margin-left:10px">
			    <el-option
			      v-for="item in raceType"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
			<el-date-picker
		      	v-model="raceStartTime"
		      	type="datetime"
		      	value-format="timestamp"
		      	placeholder="请选择开始时间" style="margin:0 10px">
		    </el-date-picker>
	    	<el-button type="primary" @click="search_mine">搜索</el-button>
	    </div>

	    <div class="main">
	      	<template>
	        	<el-table
	        		v-loading="loading"
	          		ref="multipleTable"
	          		:data="tableData"
	          		highlight-current-row
	          		tooltip-effect="dark"
	          		style="width: 100%"
	          		@current-change="handleCurrentChange">
		          	<el-table-column prop="name"  label="赛场名"></el-table-column>
		          	<el-table-column prop="sportsKindId"  label="运动类型">
		          		<template slot-scope="scope">
				    		{{scope.row.sportsKindId==1?'单车':'跑步机'}}
				    	</template>
		          	</el-table-column>
		          	<el-table-column prop="raceScale" label="竞赛规则">
		          		<template slot-scope="scope">
				    		{{scope.row.raceScale==1?'PK赛':'多人赛'}}
				    	</template>
		          	</el-table-column>
		          	<el-table-column prop="raceFormat" label="竞赛类型">
		          		<template slot-scope="scope">
				    		{{scope.row.raceFormat==1?'里程赛':'时长赛'}}
				    	</template>
		          	</el-table-column>
		          	<el-table-column prop="maxNumber" label="参赛人数"></el-table-column>
		          	<el-table-column prop="startTime" :formatter="this.global.dateFormat" label="开始时间"></el-table-column>
		          	<el-table-column prop="endTime" :formatter="this.global.dateFormat" label="结束时间"></el-table-column>
		          	<el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间"></el-table-column>	
	        	</el-table>
	      	</template>
      		<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination
		          	@current-change="handleCurrentChangePage"
		          	:current-page="pageNum"
		          	:page-size="limit"
		          	layout="total, prev, pager, next, jumper"
		          	:total="totalPage"
	        	></el-pagination>
      		</div>
    	</div>

    	<!-- 弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="200px">
      			<el-form-item label="赛场ID" prop="id" v-if="ruleForm.id">
          			{{ruleForm.id}}
        		</el-form-item>
        		<el-form-item label="赛场名称" prop="name">
          			<el-input v-model="ruleForm.name" placeholder="请输入赛场名称"  style="width: 80%;"></el-input>
        		</el-form-item>
        		<el-form-item label="运动类型" prop="sportsKindId">
				    <el-select v-model="ruleForm.sportsKindId" placeholder="请选择运动类型" style="width: 80%;" >
				    	<el-option :label="item.label" :value="item.value" :key="item.value" v-for="item in sportsKindList"></el-option>
				    </el-select>	
        		</el-form-item>
        		<el-form-item label="竞赛规则" prop="raceScale">
				    <el-select v-model="ruleForm.raceScale" placeholder="请选择竞赛规则" style="width: 80%;" >
				    	<el-option :label="item.label" :value="item.value" :key="item.value" v-for="item in ruleContest"></el-option>
				    </el-select>	
        		</el-form-item>
        		<el-form-item label="竞赛类型" prop="raceFormat">
				    <el-select v-model="ruleForm.raceFormat" placeholder="请选择竞赛类型" style="width: 80%;" >
				    	<el-option :label="item.label" :value="item.value" :key="item.value" v-for="item in raceType"></el-option>
				    </el-select>	
        		</el-form-item>
        		<el-form-item label="时长" prop="duration" v-if="ruleForm.raceFormat==2">
          			<el-input v-model="ruleForm.duration" placeholder="请输入时长"  style="width: 80%;"></el-input> 分钟
        		</el-form-item>
        		<el-form-item label="里程" prop="mileage" v-if="ruleForm.raceFormat==1">
          			<el-input v-model="ruleForm.mileage" placeholder="请输入里程"  style="width: 80%;"></el-input> 公里
        		</el-form-item>

        		<el-form-item label="人数限制" v-if="ruleForm.raceScale==1">
        			<div>{{ruleForm.maxNumber?ruleForm.maxNumber:2}}</div>
        		</el-form-item>

        		<el-form-item label="人数限制" prop="maxNumber" v-if="ruleForm.raceScale==2">
          			<el-input v-model="ruleForm.maxNumber" placeholder="请输入最大人数限制"  style="width: 80%;"></el-input>
        		</el-form-item>

        		<!-- 上传图片 -->
        		<el-form-item label="屏端封面(460px*254px)" prop="coverPic">
          			<el-input v-model="ruleForm.coverPic" placeholder='请输入屏端封面链接' style="width: 80%;"></el-input>
          			<el-upload
            			class="avatar-uploader"
			            :action="tmpFiles"
			            :show-file-list="false"
			            :headers="headers"
			            :on-success="handleAvatarSuccess"
          			>
	            		<img v-if="ruleForm.coverPic" :src="ruleForm.coverPic" class="avatar" />
	            		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
          			</el-upload>
        		</el-form-item>
        		<el-form-item label="手机端封面(690px*380px)" prop="coverAppPic">
          			<el-input v-model="ruleForm.coverAppPic" placeholder='请输入手机端封面链接' style="width: 80%;"></el-input>
          			<el-upload
            			class="avatar-uploader"
			            :action="tmpFiles"
			            :show-file-list="false"
			            :headers="headers"
			            :on-success="handleAvatarSuccess2"
          			>
	            		<img v-if="ruleForm.coverAppPic" :src="ruleForm.coverAppPic" class="avatar" />
	            		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
          			</el-upload>
        		</el-form-item>
        		<el-form-item label="开始时间" prop="startTime">
          			<el-date-picker v-model="ruleForm.startTime" type="datetime" value-format="timestamp" placeholder="请选择开始时间" style="width: 80%;"></el-date-picker>
        		</el-form-item>
        		<el-form-item label="结束时间" prop="endTime">
          			<el-date-picker v-model="ruleForm.endTime" type="datetime" value-format="timestamp" placeholder="请选择结束时间" style="width: 80%;"></el-date-picker>
        		</el-form-item>
        		<!-- <el-form-item label="请输入排名序号" prop="mobile">
          			<el-input v-model="ruleForm.mobile" placeholder="请输入排名序号"  style="width: 80%;"></el-input>
        		</el-form-item> -->
      		</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="dialogVisible = false">取 消</el-button>
        		<el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
      		</span>
    	</el-dialog>

	</div>
</template>

<script>
export default {
  	mounted() {
		this.init();
  	},
  	data() {
    	return {
    		headers: {
        		xqiao_token: localStorage.getItem("token")
      		},
	      	tmpFiles: process.env.API_ROOT + "/tmpFiles",
    		sportsKindList: [
    			{
		          value: 1,
		          label: '单车'
		        },
		        {
		          value: 2,
		          label: '跑步机'
		        }
		    ],
		    ruleContest:[
		    	{
		    		value: 1,
		          	label: 'PK赛'
		    	},
		    	{
		    		value: 2,
		          	label: '多人赛'
		    	}
		    ],
		    raceType:[
		    	{
		    		value: 1,
		          	label: '里程赛'
		        },
		        {
		    		value: 2,
		          	label: '时长赛'
		    	}
		    ],
		    sportsKindId: '',
		    raceScaleId:'',
		    raceFormatId:'',
		    raceStartTime:'',

		    tableData: [],
	      	pageNum: 1,
	      	limit: 10,
	      	totalPage: 10,
	      	currentRow: "",
	      	dialogVisible: false,
	      	loading:true,
	      	ruleForm: {
	      		coverPic:'',
	      		coverAppPic:'',
	      		minEnterPoints:0
	      	},
	      	rules: {
		        name:[{ required: true, message: "请输入赛场名称", trigger: 'blur' }],
		       	sportsKindId:[{ required: true, message: '请选择运动类型', trigger: 'change' }],
		       	raceScale:[{ required: true, message: '请选择竞赛规则', trigger: 'change' }],
		       	raceFormat:[{ required: true, message: '请选择竞赛类型', trigger: 'change' }],
		       	duration:[{ required: true, message: "请输入时长", trigger: 'blur' }],
		       	mileage:[{ required: true, message: "请输入里程", trigger: 'blur' }],
		       	maxNumber:[{ required: true, message: "请输入最大人数限制", trigger: 'blur' }],
		       	coverPic:[{ required: true, message: '请输入屏端封面链接', trigger: 'blur' }],
		       	coverAppPic:[{required: true, message: '请输入手机端封面链接', trigger: 'blur' }],
		       	startTime:[{ required: true, message: '请选择开始时间', trigger: 'change' }],
		       	endTime:[{ required: true, message: '请选择结束时间', trigger: 'change' }],
	      	},
	    };
  	},
  	methods:{
  		add(row){
  			this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	this.ruleForm={
	        		coverPic:'',
		      		coverAppPic:'',
		      		minEnterPoints:0
	        	}
	      	}
	      	this.dialogVisible = true;
	      	this.currentRow='';
  		},
	    edit(){
	    	// if (this.$refs.ruleForm != undefined) {
	     //    	this.$refs.ruleForm.resetFields();
	     //  	}
	    	if(this.currentRow.id){
	    		this.ruleForm=this.currentRow;
	    		this.dialogVisible = true;
	    	}else {
	        	this.dialogVisible = false;
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    	
	    },
	    del(){
	      	if (this.currentRow.id) {
	        	this.$confirm("确定要删除吗?", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
	          	})
	          	.then(() => {
	          		var data={id:this.currentRow.id};
	            	this.$post("/race/delRaceDetail", JSON.stringify(data))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: '删除成功',
	                    		type: "success"
	                  		});
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	})
	      	} else {
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
	    search_mine(){
	    	this.init()
	    },
    	init() {//初始化表格数据
      		var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		sportsKindId:this.sportsKindId,
        		raceScale:this.raceScaleId,
        		raceFormat:this.raceFormatId,
        		raceStartTime:this.raceStartTime
      		};
      		this.$get("/race/getRaceList", params)
        	.then(res => {
          		if (res.code == 0) {
            		this.tableData = res.data.list;
            		this.totalPage = res.data.total;
            		this.loading=false;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
    	},
    	//选择需要修改的权限
    	handleCurrentChange(val) {
      		if (val) {
        		this.currentRow = val;
      		}
    	},
    	//当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
	    //弹框关闭按钮
    	handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	//this.$refs.ruleForm.clearValidate();
	      	}
	      	done();
    	},
    	onSubmit(formName) {
    		if(this.ruleForm.raceFormat==1){
    			this.ruleForm.duration=0
    		}else{
    			this.ruleForm.mileage=0
    		}
    		if(this.ruleForm.raceScale==1){
    			this.ruleForm.maxNumber=2
    		}
    		this.$refs[formName].validate((valid) => {
	          	if (valid) {	      	
	            	console.log(this.ruleForm)
	            	//return false
	            	this.$post("/race/addRaceDetail", JSON.stringify(this.ruleForm))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: this.ruleForm.id?'修改成功':'添加成功',
	                    		type: "success"
	                  		});		                  		
	                  		this.$refs.ruleForm.resetFields();
	                  		this.$refs.ruleForm.clearValidate();
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	}
	        });
    	},
    	//选择图片成功
    	handleAvatarSuccess(res, file) {
      		console.log(res);
      		this.ruleForm.coverPic = res.data.url;
    	},
    	handleAvatarSuccess2(res, file) {
      		console.log(res);
      		this.ruleForm.coverAppPic = res.data.url;
    	},
  	}
}
</script>
<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
</style>


// WEBPACK FOOTER //
// src/views/competitionManagement/index.vue